import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2Error = loadable(() => import('./PSD2Error'), {
  fallback: <Loader />,
});
